export default "__VITE_ASSET__o8OE0ug___"